export default __webpack_public_path__ + "static/media/Laser_0002_Small-laser.b97f64db.png";